import React from 'react';
import { Helmet } from 'react-helmet';

const AccountDeletion = () => {
  return (
    <div style={{
      background: '#0A0A0F',
      minHeight: '100vh',
      color: '#E0E0E0',
      fontFamily: '-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif',
      lineHeight: 1.7,
      padding: '60px 20px',
    }}>
      <Helmet>
        <title>Delete Your Account — SafePulse Authenticator | Erasys</title>
        <meta name="description" content="Request deletion of your SafePulse Authenticator account and all associated data." />
      </Helmet>

      <div style={{ maxWidth: 720, margin: '0 auto' }}>
        <span style={{
          display: 'inline-block',
          background: 'rgba(0,229,255,0.13)',
          color: '#00E5FF',
          padding: '2px 10px',
          borderRadius: 6,
          fontSize: 13,
          fontWeight: 600,
          marginBottom: 8,
        }}>SafePulse Authenticator</span>

        <h1 style={{ fontSize: 28, color: '#00E5FF', marginBottom: 8 }}>Delete Your Account</h1>
        <p style={{ color: '#B0B0B0', marginBottom: 24 }}>
          Published by <strong style={{ color: '#fff' }}>Erasys</strong> — developer of SafePulse Authenticator on Google Play.
        </p>

        <h2 style={{ fontSize: 20, color: '#fff', marginTop: 32, marginBottom: 12 }}>How to Request Account Deletion</h2>
        <p style={{ color: '#B0B0B0', marginBottom: 16 }}>
          You can delete your SafePulse Authenticator account and all associated data using either of the following methods:
        </p>

        <h3 style={{ color: '#fff', marginTop: 20, marginBottom: 10, fontSize: 17 }}>Option 1: From Within the App</h3>
        <ol style={{ paddingLeft: 24, marginBottom: 16, color: '#B0B0B0' }}>
          <li style={{ marginBottom: 8 }}>Open <strong style={{ color: '#fff' }}>SafePulse Authenticator</strong> on your device.</li>
          <li style={{ marginBottom: 8 }}>Go to <strong style={{ color: '#fff' }}>Settings</strong> (gear icon in the top-right corner).</li>
          <li style={{ marginBottom: 8 }}>Tap <strong style={{ color: '#fff' }}>"Log Out"</strong> to sign out and clear all local data.</li>
          <li style={{ marginBottom: 8 }}>To fully delete your server-side account, use Option 2 below.</li>
        </ol>

        <h3 style={{ color: '#fff', marginTop: 20, marginBottom: 10, fontSize: 17 }}>Option 2: Request Deletion via Email</h3>
        <ol style={{ paddingLeft: 24, marginBottom: 16, color: '#B0B0B0' }}>
          <li style={{ marginBottom: 8 }}>Send an email to <a href="mailto:support@erasys.co.uk" style={{ color: '#00E5FF', textDecoration: 'none' }}>support@erasys.co.uk</a>.</li>
          <li style={{ marginBottom: 8 }}>Use the subject line: <strong style={{ color: '#fff' }}>"Account Deletion Request — SafePulse Authenticator"</strong>.</li>
          <li style={{ marginBottom: 8 }}>Include the <strong style={{ color: '#fff' }}>email address</strong> associated with your SafePulse account.</li>
          <li style={{ marginBottom: 8 }}>We will process your request and permanently delete your account within <strong style={{ color: '#fff' }}>30 days</strong>.</li>
          <li style={{ marginBottom: 8 }}>You will receive a confirmation email once deletion is complete.</li>
        </ol>

        <h2 style={{ fontSize: 20, color: '#fff', marginTop: 32, marginBottom: 12 }}>Data That Will Be Deleted</h2>
        <p style={{ color: '#B0B0B0', marginBottom: 16 }}>
          Upon account deletion, the following data is <strong style={{ color: '#fff' }}>permanently removed</strong> from our servers:
        </p>

        <div style={{ overflowX: 'auto', marginBottom: 24 }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: '#12121a' }}>
                <th style={{ textAlign: 'left', padding: '10px 14px', borderBottom: '1px solid #1a1a2e', color: '#fff', fontWeight: 600 }}>Data Type</th>
                <th style={{ textAlign: 'left', padding: '10px 14px', borderBottom: '1px solid #1a1a2e', color: '#fff', fontWeight: 600 }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {[
                ['Email address', 'deleted'],
                ['Display name', 'deleted'],
                ['Authentication tokens (JWT)', 'deleted'],
                ['TOTP account secrets', 'deleted'],
                ['Shape authentication patterns', 'deleted'],
                ['Device registration info', 'deleted'],
                ['MFA challenge history', 'deleted'],
              ].map(([type], i) => (
                <tr key={i}>
                  <td style={{ padding: '10px 14px', borderBottom: '1px solid #1a1a2e', color: '#B0B0B0' }}>{type}</td>
                  <td style={{ padding: '10px 14px', borderBottom: '1px solid #1a1a2e', color: '#FF4D4F' }}>Permanently deleted</td>
                </tr>
              ))}
              <tr>
                <td style={{ padding: '10px 14px', borderBottom: '1px solid #1a1a2e', color: '#B0B0B0' }}>Server-side security logs</td>
                <td style={{ padding: '10px 14px', borderBottom: '1px solid #1a1a2e', color: '#FFA500' }}>Retained for 90 days (legal/security compliance), then deleted</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h2 style={{ fontSize: 20, color: '#fff', marginTop: 32, marginBottom: 12 }}>Retention Period</h2>
        <p style={{ color: '#B0B0B0', marginBottom: 24 }}>
          All personal data is deleted within <strong style={{ color: '#fff' }}>30 days</strong> of receiving your request. Anonymised security audit logs may be retained for up to <strong style={{ color: '#fff' }}>90 days</strong> after deletion for fraud prevention and legal compliance, after which they are permanently purged.
        </p>

        <h2 style={{ fontSize: 20, color: '#fff', marginTop: 32, marginBottom: 12 }}>Contact Us</h2>
        <p style={{ color: '#B0B0B0', marginBottom: 24 }}>
          If you have any questions about your data or this process, contact us at:<br />
          <strong style={{ color: '#fff' }}>Email: </strong>
          <a href="mailto:support@erasys.co.uk" style={{ color: '#00E5FF', textDecoration: 'none' }}>support@erasys.co.uk</a>
        </p>

        <a
          href="mailto:support@erasys.co.uk?subject=Account%20Deletion%20Request%20%E2%80%94%20SafePulse%20Authenticator&body=Please%20delete%20my%20SafePulse%20Authenticator%20account.%0A%0AMy%20account%20email%3A%20%5Benter%20your%20email%20here%5D"
          style={{
            display: 'inline-block',
            marginTop: 20,
            padding: '12px 28px',
            background: '#00E5FF',
            color: '#0A0A0F',
            fontWeight: 700,
            borderRadius: 8,
            textDecoration: 'none',
            fontSize: 16,
          }}
        >
          Request Account Deletion
        </a>

        <div style={{
          marginTop: 48,
          paddingTop: 24,
          borderTop: '1px solid #1a1a2e',
          fontSize: 13,
          color: '#666',
        }}>
          <p>&copy; 2026 Erasys. All rights reserved.</p>
          <p>SafePulse Authenticator — <a href="https://erasys.co.uk" style={{ color: '#00E5FF', textDecoration: 'none' }}>erasys.co.uk</a></p>
        </div>
      </div>
    </div>
  );
};

export default AccountDeletion;
